import type { useToast } from "@/hooks/use-toast";

type Toast = ReturnType<typeof useToast>["toast"];

interface FolderCreationContextInput {
  projectId: string | null;
  userId: string | number | null | undefined;
  organizationId: string | null | undefined;
  toast: Toast;
}

export function getFolderCreationContext({
  projectId,
  userId,
  organizationId,
  toast,
}: FolderCreationContextInput) {
  if (!projectId) return null;
  if (!userId) {
    toast({
      variant: "destructive",
      title: "Sign-in required",
      description: "Please sign in to create folders.",
    });
    return null;
  }
  if (!organizationId) {
    toast({
      variant: "destructive",
      title: "Organisation required",
      description: "Pick an organisation first.",
    });
    return null;
  }
  return { projectId, userId: String(userId), organizationId };
}
